// Play-menu grouping for the dashboard play sheet (plan G1c). Options split into
// two groups:
//   "near" — 今天/本周类: small, incremental advances (one day/week/month, one
//            pick, continue, stop). The default bucket, so new engine options
//            surface here rather than being hidden.
//   "far"  — 到季后赛/到选秀/到自由市场类: jumps to a future milestone/phase or a
//            "view that phase" navigation.
// Option ids come from server/worker/util/updatePlayMenu.ts.
export type PlayOptionGroup = "near" | "far";

const FAR_PLAY_OPTION_IDS = new Set<string>([
	"untilAllStarGame",
	"untilTradeDeadline",
	"untilPlayoffs",
	"throughPlayoffs",
	"untilDraft",
	"untilEnd",
	"untilResignPlayers",
	"untilFreeAgency",
	"untilPreseason",
	"untilRegularSeason",
	"viewAllStar",
	"viewDraftLottery",
	"viewDraft",
	"seasonSummary",
]);

export const classifyPlayOption = (id: string): PlayOptionGroup =>
	FAR_PLAY_OPTION_IDS.has(id) ? "far" : "near";
